module.exports = __webpack_public_path__ + "static/media/tiktok.8fe965cf.png";